<template lang="html">
	<div class="omapi-plan" :class="`level-${plan.id}`">
		<div class="omapi-plan__header">
			<div class="omapi-plan__pricing">
				<div class="omapi-plan__title">{{ plan.shortName.replace('Yearly', '') }}</div>
				<div class="omapi-plan__description">{{ plan.description }}</div>
				<div class="omapi-plan__pricing-regular">normally ${{ amount }}</div>
				<div class="omapi-plan__pricing-offer">
					<span class="omapi-plan__pricing-currency">$</span>
					{{ discounted }}
					<span v-if="plan.id !== 'free'" class="omapi-plan__pricing-billing-period"> / month </span>
					<p v-if="$get('plan.price.notation')" class="omapi-plan__pricing-notation">
						({{ plan.price.notation }})
					</p>
				</div>
			</div>
			<div class="omapi-plan__action-btn-container">
				<wizard-next-link
					ref="toFocus"
					type="button"
					class="omapi-button omapi-button__green omapi-button__xlarge"
					text="Get Started"
					:disabled="isLoading"
					@click.prevent="$emit('initCheckout', plan.id)"
				/>
			</div>
		</div>
		<div class="omapi-plan__content">
			<div class="omapi-plan__features-heading">{{ plan.featureHeading }}</div>
			<div v-for="(feature, featIndex) in plan.features" :key="featIndex" class="omapi-plan__features">
				<div v-if="feature.type" class="omapi-plan__features-type">{{ feature.type }}</div>
				<ul class="omapi-plan__features-items">
					<!-- eslint-disable-next-line vue/no-v-html -->
					<li v-for="(item, itemIndex) in feature.items" :key="itemIndex" v-html="item"></li>
				</ul>
			</div>
			<a
				class="omapi-pricing-tray__link"
				:href="marketingUrl('pricing', 'OnboardingWizard', plan.level)"
				target="_blank"
			>
				Explore all features...
			</a>
		</div>
		<div v-if="plan.mostPopular" class="omapi-plan__popular">Most Popular</div>
	</div>
</template>

<script lang="js">
import { marketingSso } from '@/components/mixins/marketingSso'

export default {
	mixins: [marketingSso],
	props : {
		plan : {
			type     : Object,
			required : true,
		}
	},
	computed: {
		isLoading () {
			return this.$store.getters.isLoading([ 'connect', 'wizard' ])
		},
		amount () {
			return this.$get('plan.price.amount', '').replace('.00', '')
		},
		discounted () {
			return this.$get('plan.price.discounted', '').replace('.00', '')
		},
	}
};
</script>
